import { render, staticRenderFns } from "./appSearchers.vue?vue&type=template&id=519cf4fc&scoped=true"
import script from "./appSearchers.vue?vue&type=script&lang=js"
export * from "./appSearchers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519cf4fc",
  null
  
)

export default component.exports